import React from 'react'
import RefreshButton from '../../RefreshSearchButton'

const PreSearchFooter = () => <RefreshButton />

export default PreSearchFooter



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/PreSearch/index.jsx